
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form22DataInfoType } from '@/types/Information/Form22';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form22Layout extends Vue {

    @Prop({required:true})
    result!: form22DataInfoType;
    get computedIncome1(): string {
        if (this.result.income == 1) {
            return `<i>1-3 household members</i> - Household gross income is $${this.formatCurrency(this.result.incomeValue1)}`;
        } else {
            return `<i>1-3 household members</i> - Household gross income is $........`;
        }
    }
    get computedIncome2(): string {
        if (this.result.income == 2) {
            return `<i>4 or more household members</i> - Household gross income is $${this.formatCurrency(this.result.incomeValue2)}`;
        } else {
            return `<i>4 or more household members</i> - Household gross income is $........`;
        }
    }
    get computedAsset(): string {
        if (this.result.assets) {
            return `The value of household assets, after subtracting any outstanding debt owing on them, is $${this.formatCurrency(this.result.assetsValue)}`;
        } else {
            return `The value of household assets, after subtracting any outstanding debt owing on them, is $........`;
        }
    }

    formatCurrency(value: string): string {
        return parseInt(value).toLocaleString('en-US');
    }
}
